import React from "react";
import "./ExperienceItem.css"
import { BsFillPatchCheckFill } from "react-icons/bs"

const ExperienceItem = ({ title, link }) => (
  <article className='experience__details'>
    <BsFillPatchCheckFill className="experience__details-icon" />
    <div>
      <p>{title}</p>
    </div>
  </article>
);

export default ExperienceItem;
